var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoSubtitles = function SvgIcoSubtitles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M1 16a1 1 0 0 0 1 1h10v3a1 1 0 0 0 1.625.78L18.35 17H22a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1zm7-2H5a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2m5 0h-2a1 1 0 1 1 0-2h2a1 1 0 1 1 0 2m3 0h3a1 1 0 1 0 0-2h-3a1 1 0 1 0 0 2",
    clipRule: "evenodd"
  })));
};
export default SvgIcoSubtitles;